const sectionAllowsLink = (section) => !sectionIsEventList(section)

const sectionIsEventList = (section) =>
  section.columns.length == 1 &&
  section.columns[0].blocks[0].type === 'eventList'

export { sectionAllowsLink }
